import menu_permission from '../../middleware/menu_permission';

const routes = [
  //1. Route for My classes
  {
    path: '/user/training_classes',
    component: () => import('../Training/Teacher/training_classes'),
    name: 'TrainingClasses',
    meta: {
      permission: 'create_class_freelancer.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/freelancer/add_class',
    component: () => import('../Training/Teacher/addClass'),
    name: 'AddClass',
    meta: {
      permission: 'create_class_freelancer.create',
      middleware: [menu_permission],
    },
  },
  {
    // path: '/user/class/edit:id/:userId',
    path: '/user/training/class/edit/:id/:userId',
    component: () => import('../Training/Teacher/addClass'),
    name: 'EditClass',
    meta: {
      permission: 'create_class_freelancer.edit',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/viewReview',
    component: () => import('../Training/Teacher/courseReviews'),
    name: 'ViewCourseReview',
  },
  {
    path: '/user/enrolledStudents',
    component: () => import('../Training/Teacher/enrolledStudent'),
    name: 'EnrolledStudents',
  },

  //2. Route for My class
  {
    path: '/user/myclass',
    component: () => import('../Training/MyClass/myclass'),
    name: 'MyClass',
    meta: {
      permission: 'saved_class_freelancer.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/user/browseclass',
    component: () => import('../Training/BrowseClass/browseclass'),
    name: 'BrowseClass',
    meta: {
      permission: 'browse_class_freelancer.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/subscriptionPacks',
    component: () => import('../Training/Subscription/subscription_pack'),
    name: 'SubscriptionPacks',
  },
];
export default routes;
